import { useEffect, useRef } from "react"

const useBrowserLock = () => {
  const lockResolverRef = useRef<((value?: unknown) => void) | null>(null)
  const lockAcquiredRef = useRef(false)

  useEffect(() => {
    if (lockAcquiredRef.current) return
    
    if (navigator && navigator.locks && navigator.locks.request) {
      const promise = new Promise((res) => {
        lockResolverRef.current = res
      })

      navigator.locks.request(
        'autopilot_shared_lock',
        {
          mode: 'shared',
        },
        () => {
          lockAcquiredRef.current = true
          return promise
        }
      )
    }

    return () => {
      if (lockResolverRef.current) {
        lockResolverRef.current()
        lockResolverRef.current = null
      }
      lockAcquiredRef.current = false
    }
  }, [])
}

export default useBrowserLock